import React from 'react';

const TennisMatchDetails = ({
  eventDetails,
}) => {
  const {
    playerOne, playerTwo, playerOneSetScore,
    playerTwoSetScore, flagMatchEnded,
  } = eventDetails;
  const isPlayerOneWinning = flagMatchEnded && (playerOneSetScore > playerTwoSetScore);
  const isPlayerTwoWinning = flagMatchEnded && (playerTwoSetScore > playerOneSetScore);
  const classNameTeamWon = 'timeline__panel-team--won';
  const classNameTeam = 'timeline__panel-team';

  return (
    <div className="timeline m-t-30">
      <div className="timeline__row">
        <div className="timeline__panel text-right panel--tennisLeft">
          <div className="timeline__panel-score">{playerOneSetScore}</div>
          <div className={[classNameTeam,
            isPlayerOneWinning ? classNameTeamWon : ''].join(' ')}
          >
            {playerOne}

          </div>
        </div>
        <div className="timeline__gutter"><span>:</span></div>
        <div className="timeline__panel panel--tennisRight">
          <div className="timeline__panel-score">{playerTwoSetScore}</div>
          <div className={[classNameTeam,
            isPlayerTwoWinning ? classNameTeamWon : ''].join(' ')}
          >
            {playerTwo}

          </div>
        </div>
      </div>
      <div className="timeline__row m-t-20">
        <div className="timeline__status-wrap">
          <div className="timeline__status">
            {flagMatchEnded ? 'Finished' : 'In Progress'}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TennisMatchDetails;
